import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

const Signature = ({ signatureFile,signatureLoader }) => {
  const [isSave, setisSave] = useState(false);
  const sigPad = useRef(null);

  const clearSignature = () => {
    sigPad.current.clear();
  };

  const base64ToFile = (base64String, fileName) => {
    const [meta, base64Data] = base64String.split(",");
    const byteString = atob(base64Data);
    const byteArray = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }

    const mimeType = meta.match(/data:(.*?);base64/)[1];
    return new File([byteArray], fileName, { type: mimeType });
  };

  const saveSignature = () => {
    setisSave(true)
    if (sigPad.current.isEmpty()) {
      alert("Please provide a signature first.");
      // setisSave(false)
    } else {
      const signatureData = sigPad.current
      .getTrimmedCanvas()
      .toDataURL("image/png");
      
      signatureFile(base64ToFile(signatureData, `${Math.random()}.png`));
      // setisSave(false)
    }
  };

  return (
    <div style={{ textAlign: "center", margin: "20px" }}>
      <h1 className="font-popinsMedium text-sm text-darkColor">
        Digital Signature
      </h1>
      <div
        style={{
          margin: "10px auto",
          border: "2px solid #ccc",
          width: "500px",
          height: "200px",
          borderRadius: "5px",
        }}
      >
        <SignatureCanvas
          ref={sigPad}
          penColor="black"
          canvasProps={{ width: 500, height: 200, className: "sigCanvas" }}
        />
      </div>
      <div className="flex justify-center" style={{ marginTop: "10px" }}>
        <button
          onClick={clearSignature}
          className="font-popinsSemiBold !text-sm"
          style={{
            marginRight: "10px",
            padding: "10px 20px",
            backgroundColor: "#E43B3B",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Clear
        </button>
        <button
          onClick={saveSignature}
          className="font-popinsSemiBold text-sm flex items-center"
          style={{
            padding: "10px 20px",
            backgroundColor: "#FF814E",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          <span>Save</span>
          {signatureLoader && 
            <div role="status" className="pl-2">
              <svg
                aria-hidden="true"
                class="w-5 h-5 text-gray-200 animate-spin dark:text-gray-500 fill-themeColor  "
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span class="sr-only">Loading...</span>
            </div>
          }
        </button>
      </div>
    </div>
  );
};

export default Signature;
